import { ingestAPIObject } from "../utils/api";
export class CropDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
    get fullName() {
        if (!this.commodity)
            return "Unknown Crop";
        if (!this.variety)
            return this.commodity;
        return `${this.commodity}: ${this.variety}`;
    }
}
